import { Star06Icon } from '@langchain/untitled-ui-icons';

import { useState } from 'react';

import { cn } from '@/utils/tailwind';

import { PlaygroundIcon } from '../PlaygroundHome/PlaygroundButtons';
import { ConfigureOptimizeModal } from './ConfigureOptimizeModal';

export const OptimizePrompt = ({
  initialPromptIdentifier,
  disabledMessage,
}: {
  initialPromptIdentifier?: string;
  disabledMessage?: string;
}) => {
  const [isConfigureOptimizeModalOpen, setIsConfigureOptimizeModalOpen] =
    useState(false);

  const onClose = () => {
    setIsConfigureOptimizeModalOpen(false);
  };

  return (
    <>
      <PlaygroundIcon
        tooltipTitle={
          disabledMessage ?? !initialPromptIdentifier
            ? 'Select a prompt to optimize'
            : 'Optimize prompt'
        }
        className="my-1"
        disabled={!!disabledMessage}
      >
        <button
          type="button"
          onClick={() => setIsConfigureOptimizeModalOpen(true)}
          className={cn(
            disabledMessage && 'cursor-normal opacity-50 hover:bg-background'
          )}
          disabled={!!disabledMessage || !initialPromptIdentifier}
        >
          <div className="mx-[1px] my-[3px]">
            <Star06Icon className="my-auto h-4 w-4" />
          </div>
        </button>
      </PlaygroundIcon>
      {initialPromptIdentifier && (
        <ConfigureOptimizeModal
          isOpen={isConfigureOptimizeModalOpen}
          onClose={onClose}
          initialPromptIdentifier={initialPromptIdentifier}
        />
      )}
    </>
  );
};
